export const blockedCountries = [
  'IR',
  'SY',
  'KP',
  'CU',
  'RU',
  'UA',
  'VE',
  'BY',
  'IN',
  'PK',
  'CO',
  'NG',
  'BD',
  'CN',
  'TH',
  'TR',
  'PH',
];
